import { createAction, props } from '@ngrx/store';

export const checkAutopayEligibility = createAction(
  '[Payment Summary Component] Check Autopay Eligibility',
  props<{
    tenantId: string;
    accountNumbers: string[];
  }>(),
);

export const enrollInAutopayClicked = createAction(
  '[Payment Summary Component] Enroll In Autopay Clicked',
);
